import { render, staticRenderFns } from "./MentorshipGroups.vue?vue&type=template&id=5b9a3f36"
import script from "./MentorshipGroups.vue?vue&type=script&lang=js"
export * from "./MentorshipGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports